import { render } from "./PackCardItem.vue?vue&type=template&id=da921d5c&scoped=true"
import script from "./PackCardItem.vue?vue&type=script&lang=js"
export * from "./PackCardItem.vue?vue&type=script&lang=js"

import "./PackCardItem.vue?vue&type=style&index=0&id=da921d5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da921d5c"]])

export default __exports__